import { Outlet } from 'react-router-dom';
import { AppShell, Container, Group, Text } from '@mantine/core';

export function PublicAppLayout() {
  return (
    <AppShell header={{ height: 60 }} padding="md">
      <AppShell.Header>
        <Group align="center" h="100%" px="md">
          <Text fw={700}>Ametista AI</Text>
        </Group>
      </AppShell.Header>
      <AppShell.Main>
        <Container size="md" py="xl">
          <Outlet />
        </Container>
      </AppShell.Main>
    </AppShell>
  );
}
